import { Link } from 'wouter';
import '../../assets/css/pages/Blog.css';

interface BlogItemProps {
    post: any;
}

export default function BlogItem({ post }: BlogItemProps) {

    const categoryColors: Record<string, string> = {
        'Web Dev': 'linear-gradient(135deg, #0f2027, #0f3460)',
        'Mobile': 'linear-gradient(135deg, #0f2027, #2c5364)',
        'Cloud': 'linear-gradient(135deg, #0a2342, #1e3a5f)',
        'Design': 'linear-gradient(135deg, #1f0533, #5a1091)',
        'AI/ML': 'linear-gradient(135deg, #0a3d0a, #1a5c1a)',
        'Security': 'linear-gradient(135deg, #1a0a0a, #7b2d2d)',
    };

    return (
        <>
            <div className="blog-card" key={post.slug}>
                <div className="blog-card-strip" style={{ background: categoryColors[post.category] || '#0f3460' }}>
                    <i className={`fa-solid fa-${post.icon}`}></i>
                </div>
                <div className="blog-card-body">
                    <span className="blog-cat-badge">{post.category}</span>
                    <h2 className="blog-title">{post.title}</h2>
                    <p className="blog-excerpt">{post.excerpt}</p>
                    <div className="blog-meta">
                        <span><i className="fa-regular fa-calendar"></i> {post.date}</span>
                        <span><i className="fa-regular fa-clock"></i> {post.readTime}</span>
                    </div>
                    <Link href={`/blog/${post.slug}`} className="blog-read-more">Read More <i className="fa-solid fa-arrow-right"></i></Link>
                </div>
            </div>
        </>
    );
}